(() => {
  function initHero() {
    const root = document.querySelector('.slider-main_component.is-hero_bg');
    if (!root) return;
    const swiperEl = root.querySelector('.swiper.is-hero_bg');
    if (!swiperEl) return;

    // eslint-disable-next-line no-undef
    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 1000,
      autoplay: { delay: 5000, disableOnInteraction: false },
      navigation: {
        nextEl: root.querySelector('.swiper-next'),
        prevEl: root.querySelector('.swiper-prev')
      }
    });
  }

  function initProductSliders() {
    document.querySelectorAll('.slider-main_component.is-product_slider').forEach((root) => {
      const swiperEl = root.querySelector('.swiper.is-product_slider');
      if (!swiperEl) return;

      // eslint-disable-next-line no-undef
      new Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        loop: false,
        speed: 500,
        navigation: {
          nextEl: root.querySelector('.swiper-next') || undefined,
          prevEl: root.querySelector('.swiper-prev') || undefined
        },
        breakpoints: {
          480: { slidesPerView: 2.2, spaceBetween: 16 },
          768: { slidesPerView: 3.2, spaceBetween: 20 },
          992: { slidesPerView: 4.2, spaceBetween: 24 }
        }
      });
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function run() {
    if (typeof window.Swiper === 'undefined') return;
    initHero();
    initProductSliders();
  }

  window.KasuriInitProductSliders = initProductSliders;

  onReady(run);
})();


